<ion-card mode="ios" color="getm-neutral-white" class="card-content-product">
  <ng-container *ngIf="product; else loadingTemplate">
    <!-- ! TAG de recomendador -->
    <section class="m-tag-card-product">
      <ng-container *ngIf="recommender !== 0">
        <getm-tag-card-product
          [icon]="segment.icon"
          [label]="segment.title"
          [color]="segment.color"
          [fill]="product.impacto_recompra === 1 ? 'solid' : 'outline'"
          corners="tr bl"
        ></getm-tag-card-product>
      </ng-container>
    </section>

    <!-- ! Detalle de producto -->
    <ion-item
      mode="md"
      color="transparent"
      lines="none"
      class="item-detail-product"
      (click)="onProductClick()"
    >
      <ion-thumbnail slot="start" class="img-product">
        <ion-img [src]="product.imagen"></ion-img>
      </ion-thumbnail>

      <ion-label color="getm-neutral-light">
        <ion-text class="title" color="getm-neutral-dark">
          {{ product.title }}
        </ion-text>
        <br />
        <ion-text class="subtitle"> {{ product.subtitle }} </ion-text>
        <br />
        <ion-text class="too-much">
          {{ 'Labels.taste' | translate }}:&nbsp;{{ product.sku }}
        </ion-text>
        <br />
        <ion-text class="too-much">
          {{ 'Labels.sku' | translate }}:&nbsp;{{ product.clave_producto }}
          <ng-container *ngIf="!isProd">
            &nbsp;{{ 'Labels.factorcl' | translate }}: {{ product.FactorCl }}
          </ng-container>
        </ion-text>
      </ion-label>
    </ion-item>

    <!-- ! Detalle de precio y puntos -->
    <ion-item
      mode="md"
      color="transparent"
      lines="none"
      class="item-detail-price"
    >
      <ng-container
        *ngIf="
          product.puntos_recompepsi || product.muestra_texto_generico_puntos
        "
      >
        <section slot="start">
          <getm-coins-badge
            [size]="product.muestra_texto_generico_puntos ? 'small' : 'large'"
            [text]="
              product.muestra_texto_generico_puntos
                ? ('Labels.earn-points' | translate)
                : '+' + product.puntos_recompepsi
            "
          ></getm-coins-badge>
        </section>
      </ng-container>

      <section slot="end">
        <getm-price-display [price]="product.precio"></getm-price-display>
      </section>
    </ion-item>

    <!-- ! Acciones -->
    <section
      [ngClass]="{
        actions:
          !!(recommender !== 1 || product.pendientes_cajas_sio === 0) ||
          product.productos > 0
      }"
    >
      <ng-container *ngIf="product.productos < 1; else selectorQuantity">
        <ng-container
          *ngIf="
            recommender !== 1 || product.pendientes_cajas_sio === 0;
            else withSuggested
          "
        >
          <getm-button
            [text]="'Buttons.add' | translate"
            color="primary"
            size="default"
            expand="block"
            (btnClick)="onQuantityChange(1)"
          ></getm-button>
        </ng-container>
        <ng-template #withSuggested>
          <ion-grid class="actions-grid ion-no-padding">
            <ion-row class="ion-justify-content-between ion-align-items-center">
              <ion-col size="5">
                <getm-left-label-card
                  class="suggested-label"
                  [text]="
                    'Labels.suggested-products'
                      | translate
                        : {
                            quantity: product.pendientes_cajas_sio
                          }
                  "
                ></getm-left-label-card>
              </ion-col>
              <ion-col size="6.7">
                <getm-button
                  [text]="'Buttons.add' | translate"
                  color="primary"
                  size="default"
                  expand="block"
                  (btnClick)="onQuantityChange(1)"
                >
                </getm-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ng-template>
      </ng-container>

      <ng-template #selectorQuantity>
        <getm-quantity-selector
          [quantity]="product.productos"
          [minimo]="1"
          [maximo]="'RangeSelector.Store.end' | translate"
          fill="solid"
          (quantityChange)="onQuantityChange($event)"
          (removeProduct)="onRemoveProduct()"
        ></getm-quantity-selector>
      </ng-template>
    </section>
  </ng-container>

  <ng-template #loadingTemplate>
    <ion-skeleton-text animated class="loading-product"></ion-skeleton-text>
  </ng-template>
</ion-card>
